var mapByAttribute = function mapByAttribute(arr, arg) {
  return arr.map(function (item) {
    return item[arg];
  });
};

export default mapByAttribute;